import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuthProvider } from '@/hooks/auth/useAuthProvider';
import { IReactChildrenProps } from '@/interfaces/IReactChildren';
import { cookieService } from '@/services/cookie.service';

export default function RequireAuth({ children }: IReactChildrenProps) {
	const { handleRefreshSession, loadingState } = useAuthProvider();
	const location = useLocation();

	useEffect(() => {
		// Save query parameters if they exist
		const queryParams = new URLSearchParams(location.search).toString();
		if (queryParams) {
			cookieService.setRedirectQueryParams(queryParams);
		}

		handleRefreshSession();
	}, [handleRefreshSession, location.search]);

	if (loadingState.refreshSession)
		return (
			<div className="flex flex-1 items-center justify-center flex-col">
				<div className="flex flex-1 items-center justify-center">
					<span className="material-symbols-outlined animate-spin pointer-events-none">
						progress_activity
					</span>
				</div>
			</div>
		);
	else return <>{children}</>;
}
